import React, { useEffect, useRef, useState } from "react";
import { set, useForm } from "react-hook-form";
import { Box, Grid, TextField, Typography, Avatar, Paper, Button, FormControl, Tabs, Tab, InputAdornment, IconButton, Alert, Dialog, DialogTitle, DialogContent, DialogContentText, Divider, DialogActions } from "@mui/material";
import axios from "axios";
import { IconCheck, IconEye, IconEyeOff, IconLock, IconTrash, IconX } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import profileImage from '.././Images/profile.jpg'
import PageContainer from "./Pagecontainer";
import { useNavigate } from "react-router-dom";
import { se } from "suneditor/src/lang";
import ScheduleDemo from "./demo";
import Cookies from "js-cookie";
const MyProfile = () => {
  const params = new URLSearchParams(window.location.search);
   const UpdateTab = params.get("tab");
   const IsEdit = params.get("is_edit");
  const { register, handleSubmit, reset, formState: { errors }, trigger, setValue, getValues, clearErrors } = useForm({});
  const { register: register1, handleSubmit: handleSubmit1, formState: { errors: errors1 }, getValues: getValues1, trigger: trigger1, setValue: setValue1, reset: reset1, setError: setError1 } = useForm({});
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, getValues: getValues2, trigger: trigger2, setValue: setValue2, reset: reset2, setError: setError2 } = useForm({});
  const { register: Billingregister, handleSubmit: BillingSubmit, formState: { errors: billingerrors }, trigger: BillingTrigger, setValue: BillingValue, clearErrors: Billingerrors, reset: BillingReset } = useForm();
  const [loader, setloader] = useState(false)
  const [isEditing, setIsEditing] = useState(IsEdit?true:false);
 const [tabValue, setTabValue] = useState(UpdateTab ? parseInt(UpdateTab) : 0);
  useEffect(() => {
  if (UpdateTab !== null && !isNaN(UpdateTab)) {
    setTabValue(parseInt(UpdateTab));
  }
}, [UpdateTab]);
  const [Name, setName] = useState("")
  const [Mobile, setMobile] = useState('')
  const [CompanyName, setCompanyName] = useState("");
  const navigate = useNavigate()
  const [Deletepopup, setDeletepopup] = useState(false);
  const [billingId,setbillingId] = useState(null);
  console.log(billingId,'billingId');
  const onSubmit = async (data) => {
    console.log(data);
    
    setloader(true);
    try {
      let req = {
        // fullname: data.fullname,
        first_name:data.firstname,
        last_name:data.lastname,
        mobile: data.phone,
        "adress_info": [
        {
            "id":billingId?.id,
            "first_name":data.firstname,
            "last_name": data.lastname,
            "address_line_1": billingId?.address_line_1 ,
            "address_line_2": billingId?.address_line_2,
            "city": billingId?.city,
            "state": billingId?.state,
            "postal_code": billingId?.postal_code,
            "country": billingId?.country,
            "phone_number": data.phone,
            "address_type": "BILLING"
        }
    ]

      };
      const response = await axios.patch('/apiV1/update-user-info/', req);
      if (response.status == 200) {
        setIsEditing(false);
        GetData()
        setloader(false);
        setsuccesspopup(true)
        userInfo1();
      }
    } catch (error) {
      console.error('Error generating test:', error.response ? error.response.data : error.message);
      setloader(false);
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showoldPassword, setShowoldPassword] = useState(false);
  const [showconfirmPassword, setshowconfirmPassword] = useState(false)
  const [Error, setError] = useState('')
  const [success, setsuccess] = useState('')
  const [updatesuccess, setupdatesuccess] = useState(false)
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState("")
  const [successpopup, setsuccesspopup] = useState(false)
  const [passwordsuccess, setpasswordsuccess] = useState(false)
  const [DeleteSuccess, setDeleteSuccess] = useState(false)
  const userInfo = JSON.parse(Cookies.get('user-info'));
  const toggleoldPasswordVisibility = () => {
    setShowoldPassword((prev) => !prev);
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  const toggleconfirmPasswordVisibility = () => {
    setshowconfirmPassword((prev) => !prev);
  };
  const onPasswordSubmit = async (data) => {
    setError('')
    setloader(true)
    const reqData = {
      password: data.password,
      password2: data.confirmPassword,
      old_password: data.oldpassword

    }
    let req = {
        password: data.password,
        password2: data.confirmPassword
      };
      let config = axios.defaults.headers.common = { 'Authorization': `` }
      let config2 = axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
    if (data.oldpassword === data.password) {
      setError("The new password must be different from the old password")
      setloader(false)
    }
    else {
      try {
         const endpoint = setupdata?.is_password_added === false
      ? `apiV1/change-passwordv2/${userInfo?.id}/` 
      : '/apiV1/change-password/';
    const response = setupdata?.is_password_added === false
      ? await axios.patch(endpoint, req, config)
      : await axios.patch(endpoint, reqData,config2);
    // const response = await axios.patch(endpoint, reqData);
        // const response = await axios.patch(`/apiV1/change-password/`, reqData);
        if (response.status == 200) {
          setupdatesuccess(true);
          reset();
          setpasswordsuccess(true)
          // setsuccess(response.data.message)
          // setsuccesspopup(true)
          setloader(false)
          reset1()

        }
      } catch (error) {
        setError(error?.response?.data?.old_password?.old_password);
        setupdatesuccess(false);
        setloader(false)
      }

    }

  }
  
  const userInfo1 = async () => {
      try {
        const config = axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("AdminToken")}` }
        const response = await axios.get('/apiV1/user-info/', config);
        console.log(response.data);
        if (response.status == 200) {
          sessionStorage.setItem("user-info", JSON.stringify(response.data))
          Cookies.set('user-info', JSON.stringify(response.data));
        }
      } catch (error) {
        console.error('Error generating test:', error.response ? error.response.data : error.message);
      }
    }
  const GetData = async () => {
    try {
      const response = await axios.get('/apiV1/get-profile/');
      if (response.status === 200) {
        setValue("fullname", response?.data?.message?.fullname || "");
        setValue("firstname", response?.data?.message?.first_name || "");
        setValue("lastname", response?.data?.message?.last_name || "");
        setName(response?.data?.message?.fullname || "")
        setValue("email", response?.data?.message?.email || "");
        BillingValue("email", response?.data?.message?.email || "");
        setValue("phone", response?.data?.message?.mobile || "");
        // const safeValue = (val) => (val && val !== "null" ? val : " ");
        setValue2("companyName",response?.data.message?.company_name || "" ); 
        setValue2("companytagline",response?.data.message?.company_tagline || "");
        setValue2("CompanyWebsite",response?.data.message?.company_website || "");
        setCompanyName(response?.data.message?.company_name || "");
        setMobile(response?.data?.message?.mobile || "");
        // setValue2("companyName", response.data.message?.company_name || "");
        // setValue2("companytagline", response.data.message?.company_tagline || "");
        // setValue2("CompanyWebsite", response.data.message?.company_website || "");
        // setValue2("companyprofile", response.data.message.image);
        setSelectedFile(response.data.message.image)
        // setMobile(response.data.message.mobile)
        setImageUrl(response.data.message.image)
      }
    } catch (error) {
      console.error("Error fetching profile data:", error.response ? error.response.data : error.message);
    }
  };

  useEffect(() => {
    GetData();
    getbillingAddress()
  }, []);
  const [imageUrl, setImageUrl] = useState("");
  const fileInputRef = useRef(null);

  const handleImageChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    const fileSizeMB = file.size / (1024 * 1024);
    const fileType = file.type;
    const allowedTypes = [
      "image/jpeg", 
      "image/png",
      "image/gif",
      "image/tiff",
      "image/svg+xml",
      "image/webp",
      "image/bmp",
      "image/heif",
      "image/heic", 
    ];

    if (!allowedTypes.includes(fileType)) {
      alert("Only JPEG, PNG, GIF, TIFF, SVG, WebP, BMP, and HEIF formats are allowed.");
      event.target.value = "";
      return;
    }

    if (fileSizeMB > 2) {
      alert("File size must be less than 2MB.");
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
    setImageUrl(URL.createObjectURL(file));
  }
};



  const handleCompanydata = async (data) => {
    const formData = new FormData();
    formData.append("mobile", Mobile);
    formData.append("fullname", Name);
    formData.append("company_website", data.CompanyWebsite);
    formData.append("company_name", data.companyName);
    formData.append("company_tagline", data.companytagline);
    if (selectedFile instanceof File) {
      const binaryData = await selectedFile.arrayBuffer(); // Convert file to binary
      const blob = new Blob([binaryData], { type: selectedFile.type });
      formData.append("image", blob, selectedFile.name);
    }
    setloader(true)
    try {
      const response = await axios.patch("/apiV1/update-user-info/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status !== 200) {
        throw new Error("Failed to update company data");
      }

      if (response.status === 200) {
        setImageUrl(response.data.data.image);
        setIsEditing(false);
        setsuccesspopup(true)
        GetData()
        setloader(false)
      }
    } catch (error) {
      console.error("Error uploading data:", error);
      alert("Error uploading data. Please try again.");
      setloader(false)
    }
  };

  const onBillingSubmit = async (data) => {
    console.log(data);
    setloader(true)
    const req = {
      "user_id": userInfo?.id,
      "user_info": [
        {
            "name": CompanyName,
            "full_name": data.firstName + " " + data.lastName,
            "mobile": data.mobile
        }
      ],
      "adress_info": [
        {
          // id:  billingStatus?.id,
          // name: data.firstName + " " + data.lastName,
          id: billingId?.id,
          first_name:data.firstName,
          last_name:data.lastName,
          address_line_1: data.addressLine1,
          address_line_2: data.addressLine2,
          city: data.city,
          state: data.state,
          postal_code: data.zipCode,
          country: data.country,
          phone_number: data.mobile,
          address_type: "BILLING"
        }
      ]
    }
    try {
      const config2 = {
        headers: {
          Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
        },
      };
      const response = await axios.post(`${process.env.REACT_APP_API_URL2}/apiV1/update-billing_address/`, req, config2);
      if (response.status == 200 || response.status == 201) {
        setsuccesspopup(true)
        setIsEditing(false);
        setloader(false)
        BillingReset()
        GetData()
        getbillingAddress()
        userInfo1();
      }

    } catch (error) {
      console.log(error)
      setloader(false)
    }
  }
  const getbillingAddress = async () => {
    try {
      const config2 = {
        headers: {
          Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==`,
        },
      };
      const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-billing_address/?user_id=${userInfo?.id}`, config2);
      if (response.status == 200) {
        const nameParts = response.data[0]?.customer__full_name?.trim().split(" ") || [];
        const firstName = response.data[0]?.first_name || "";
        const lastName = response.data[0]?.last_name || "";
        BillingValue('firstName', firstName);
        BillingValue('lastName', lastName);
        setbillingId(response.data[0] || null);
        // BillingValue("email", response.data[0].customer__corp_email);
        BillingValue("mobile", response.data[0]?.phone_number);
        BillingValue("addressLine1", response.data[0]?.address_line_1);
        BillingValue("addressLine2", response.data[0]?.address_line_2);
        BillingValue("state", response.data[0].state);
        BillingValue("city", response.data[0].city);
        BillingValue("country", response.data[0].country);
        BillingValue("zipCode", response.data[0].postal_code);
      }

    } catch (error) {
      console.log(error)
    }
  }
  const handleDelete = async () => {
    setDeletepopup(false);
    setloader(true);
    try {
      const response = await axios.delete(`/apiV1/delete/`);
      if (response.status === 200) {
        setloader(false);
        setDeleteSuccess(true)
      }
    } catch (err) {
      console.error(err);
      setloader(false);
      setDeletepopup(false);
    }
  };
  const [setupdata, setsetupdata] = useState()

  const getSetupData = async () => {
    try {
      const response = await axios.get('/apiV1/set-up/')
      if (response.status === 200) {
        setsetupdata(response.data)
      }
    }
    catch (err) {
      console.log(err?.response?.data?.message);

    }
  }
  useEffect(() => {
    getSetupData();
  }, []);
  return (
    <>
      <PageContainer title="SmartInvestorDeck | MyProfile">
        <ScheduleDemo showBanner={true} />
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2, minHeight: "83vh" }}>
          <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, width: "100%", maxWidth: "900px", borderRadius: "10px", background: "#fff" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5} sx={{
                borderRight: { xs: "none", md: "1px solid #ddd" },
                borderBottom: { xs: "1px solid #ddd", md: "none" },
                pb: { xs: 2, md: 0 }
              }}>
                <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
                  Account Settings
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 2, mb: 2 }}>
                  <Box
                    sx={{
                      width: { xs: 100, sm: 120 },
                      height: { xs: 100, sm: 120 },
                      background: "#fff",
                      color: "#000",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "20px"
                    }}
                  >
                    <Avatar
                      src={profileImage}
                      alt={userInfo?.fullname}
                      sx={{ width: { xs: 100, sm: 120 }, height: { xs: 100, sm: 120 } }}
                    />
                  </Box>
                  <Button sx={{ mt: 2, gap: 2 }} onClick={() => setDeletepopup(true)}><IconTrash />Delete Account</Button>
                </Box>
                <Tabs
                  value={tabValue}
                  onChange={(e, newValue) => { setTabValue(newValue); reset(); reset1(); reset2();BillingReset();setIsEditing(IsEdit ? true : false);; GetData(); getbillingAddress() }}
                  sx={{ mb: 2, '& .MuiTabs-flexContainer': { flexDirection: { sm: 'column', x: "column" } } }}
                  variant="scrollable"
                  scrollButtons="auto"
                  TabIndicatorProps={{ style: { display: 'none' } }}
                >
                  {["My Profile", "Company Profile", "Billing Address", "Change Password"].map((label, index) => (
                    <Tab
                      key={label}
                      label={label}
                      sx={{
                        textTransform: "none", backgroundColor: tabValue === index ? "#71a2c0" : "#f5f5f5", color: "#000", borderRadius: "8px", mx: 1, mb: 1, fontSize: "16px", fontWeight: 500,
                        '&.Mui-selected': {
                          color: '#fff',
                          backgroundColor: '#71a2c0',
                        }
                      }}
                    />
                  ))}
                </Tabs>
              </Grid>
              <Grid item xs={12} md={7}>
                {/* Tabs with responsive styling */}
                {/* <Tabs
                            value={tabValue}
                            onChange={(e, newValue) => { setTabValue(newValue); reset(); reset1(); setIsEditing(false); GetData() }}
                            sx={{
                                mb: 2,
                                borderBottom: "1px solid #ddd",
                                '& .MuiTabs-flexContainer': {
                                    flexDirection: { sm: 'row', x: "row" }
                                }
                            }}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab label="My Profile" sx={{ color: "#000" }} />
                            <Tab label="Company Profile" sx={{ color: "#000" }} />
                            <Tab label="Billing Address" sx={{ color: "#000" }} />
                            <Tab label="Change Password" sx={{ color: "#000" }} />
                        </Tabs> */}

                {tabValue === 0 && (
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center", backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "10px" }}>My Profile</Typography>
                    <Divider sx={{ mt: 1 }} />
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>First Name</Typography>
                      <TextField
                        fullWidth
                        id="fullName-input"
                        {...register("firstname", { required: "First Name is required" ,
                          pattern: {
                            value: /^(?! )[a-zA-Z ]+$/,
                            message: "First Name must start with an alphabet. Only alphabets and spaces are allowed",
                          },
                          maxLength: {
                            value: 30,
                            message: "First Name must not exceed 30 characters",
                          },
                        })}
                        onKeyUp={() => trigger("firstname")}
                        error={!!errors.firstname}
                        helperText={errors.firstname?.message}
                        disabled={!isEditing}
                      />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Last Name</Typography>
                      <TextField
                        fullWidth
                        id="fullName-input"
                        {...register("lastname", { required: "Last Name is required" ,
                          pattern: {
                            value: /^(?! )[a-zA-Z ]+$/,
                            message: "Last Name must start with an alphabet. Only alphabets and spaces are allowed",
                          },
                          maxLength: {
                            value: 30,
                            message: "Last Name must not exceed 30 characters",
                          },
                        })}
                        onKeyUp={() => trigger("lastname")}
                        error={!!errors.lastname}
                        helperText={errors.lastname?.message}
                        disabled={!isEditing}
                      />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Email</Typography>
                      <TextField
                        fullWidth
                        id="email-input"
                        type="email"
                        {...register("email", {
                          required: "Email is required",
                          pattern: { value: /\S+@\S+\.\S+/, message: "Enter a valid email" },
                        })}
                        onKeyUp={() => trigger("email")}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        disabled={true}

                      />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Mobile Number</Typography>
                      {/* <TextField
                        fullWidth
                        id="mobile-input"
                        type="tel"
                        {...register("phone", {
                          required: "Phone Number is required",
                          pattern: {
                            value: /^[0-9]+$/,
                            message: "Only numeric values are allowed",
                          },
                          minLength: {
                            value: 10,
                            message: "Mobile number must be at least 10 digits",
                          },
                          maxLength: {
                            value: 12,
                            message: "Mobile number must not exceed 12 digits",
                          },
                        })}
                        inputProps={{
                          maxLength: 12,
                        }}
                        onKeyUp={() => trigger("phone")}
                        error={!!errors.phone}
                        helperText={errors.phone?.message}
                        disabled={!isEditing}

                      /> */}
                      <TextField
                          fullWidth
                          id="mobile-input"
                          type="tel"
                          {...register("phone", {
                            required: "Phone Number is required",
                            pattern: {
                              value: /^(?! )[+0-9()\-\s]{8,20}$/, // No leading space, allow +()- and digits
                              message: "Enter a valid number (no space at start, allow +()- and digits)",
                            },
                            minLength: {
                              value: 8,
                              message: "Mobile number must be at least 8 characters",
                            },
                            maxLength: {
                              value: 20,
                              message: "Mobile number must not exceed 20 characters",
                            },
                          })}
                          inputProps={{
                            maxLength: 20,
                            inputMode: "tel",
                          }}
                          onKeyUp={() => trigger("phone")}
                          error={!!errors.phone}
                          helperText={errors.phone?.message}
                          disabled={!isEditing}
                    />

                    </FormControl>
                    {/* <Button variant="outlined"  sx={{ mt: 2 }} onClick={() => setIsEditing(true)} disabled={isEditing}>Edit</Button> */}

                    {isEditing ?
                      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 2 }}>
                        <Button variant="outlined" color="primary" onClick={() => { setIsEditing(false); clearErrors(); GetData() }} disabled={loader}>
                          Cancel
                        </Button>
                        <Button variant="outlined" color="primary" type="submit" className="button2" disabled={loader}>
                          {loader ? <BeatLoader size={20} color="#4a77f8" /> : <Typography>Save</Typography>}
                        </Button>
                      </Box> : <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setIsEditing(true)} disabled={isEditing}>Edit</Button>}


                  </form>
                )}
                {tabValue === 1 && (
                  <form onSubmit={handleSubmit2(handleCompanydata)}>
                    <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center", backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "10px" }}>Company Profile</Typography>
                    <Divider sx={{ mt: 1 }} />
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Company Name  <span style={{ color: "red", fontWeight: 600 }}>*</span></Typography>
                      <TextField
                        fullWidth
                        id="text"
                        {...register2("companyName", {
                          required: "Company Name is required",
                          pattern: {
                        value: /^[A-Za-z][A-Za-z ]*$/,
                        message: "Company Name must start with a letter and contain only letters and spaces",
                      },
                          maxLength: {
                            value: 50,
                            message: "Company Name must not exceed 50 characters",
                          },
                        })}
                        onKeyUp={() => trigger2("companyName")}
                        error={!!errors2.companyName}
                        helperText={errors2.companyName?.message}
                        disabled={!isEditing}
                      />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Company Website</Typography>
                      <TextField
                        fullWidth
                        id="CompanyWebsite-input"
                        type="url"
                        {...register2("CompanyWebsite", {
                          pattern: {
                            value: /^https?:\/\/(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}([\/\w\.-]*)*\/?$/,
                            message: "Enter a valid website URL (e.g., https://example.com)",
                          },
                          maxLength: {
                            value: 100,
                            message: "Company Website must not exceed 100 characters",
                          },
                        })}
                        onKeyUp={() => trigger2("CompanyWebsite")}
                        error={!!errors2.CompanyWebsite}
                        helperText={errors2.CompanyWebsite?.message}
                        disabled={!isEditing}

                      />
                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Company Tagline</Typography>
                      <TextField
                        fullWidth
                        id="companytagline-input"
                        type="text"
                        {...register2("companytagline", {
                          pattern: {
                            value:/^[A-Za-z][A-Za-z0-9.,'"()\-!& ]{1,99}$/,
                            message: "Company Tagline must start with a letter and contain only letters,numbers and spaces",
                          },
                          maxLength: {
                            value: 100,
                            message: "Company Tagline must not exceed 100 characters",
                          },
                        })}
                        onKeyUp={() => trigger2("companytagline")}
                        error={!!errors2.companytagline}
                        helperText={errors2.companytagline?.message}
                        disabled={!isEditing}
                      />

                    </FormControl>
                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>Company Logo</Typography> 
                      <TextField
                        fullWidth
                        id="companyprofile"
                        type="file"
                        accept=".jpg,.jpeg,.png,.gif,.tiff,.svg,.webp,.bmp,.heif,.heic"
                        {...register2("companyprofile")}
                        disabled={!isEditing}
                        onChange={handleImageChange}
                      />
                    </FormControl>
                    <Avatar
                      sx={{ width: 120, height: 120, bgcolor: "#71a2c0", fontSize: "2rem" }}
                      src={imageUrl || ""}
                      imgProps={{ style: { objectFit: "contain" } }}
                    >
                      {!imageUrl && ""}
                    </Avatar>
                    {/* <Button variant="outlined"  sx={{ mt: 1 }} onClick={() => setIsEditing(true)} disabled={isEditing}>Edit</Button> */}

                    {isEditing ?
                      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 2 }}>
                        <Button variant="outlined" color="primary" onClick={() => { setIsEditing(false); clearErrors(); GetData() ;reset2()}} disabled={loader}>
                          Cancel
                        </Button>
                        <Button variant="outlined" color="primary" type="submit" className="button2" disabled={loader}>
                          {loader ? <BeatLoader size={20} color="#fff" /> : <Typography>Save</Typography>}
                        </Button>
                      </Box> : <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setIsEditing(true)} disabled={isEditing}>Edit</Button>}


                  </form>
                )}
                {tabValue === 2 && (
                  <form onSubmit={BillingSubmit(onBillingSubmit)}>
                    <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center", backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "10px" }}>Billing Address</Typography>
                    <Divider sx={{ mt: 1, mb: 1 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          First Name <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="First Name"
                          disabled={!isEditing}
                          error={!!billingerrors.firstName}
                          helperText={billingerrors.firstName?.message}
                          {...Billingregister("firstName", {
                            required: "First Name is required",
                            validate: value =>
                            value.trimStart() === value || "First Name should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z\s]{2,}$/,
                              message: "First Name should contain only letters",
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("firstName"); }}

                        />
                      </Grid>

                      {/* Last Name */}
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          Last Name <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Last Name"
                          error={!!billingerrors.lastName}
                          helperText={billingerrors.lastName?.message}
                          {...Billingregister("lastName", {
                            required: "Last Name is required",
                            validate: value =>
                              value.trimStart() === value || "Last Name should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z\s]+$/,
                              message: "Last Name should contain only letters",
                            },
                          })}
                          disabled={!isEditing}
                          onKeyUp={() => { BillingTrigger("lastName"); }}
                        />
                      </Grid>

                      {/* Email */}
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          Email <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Email"
                          disabled={true}
                          error={!!billingerrors.email}
                          helperText={billingerrors.email?.message}
                          {...Billingregister("email", {
                            required: "Email is required",
                            pattern: {
                              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                      </Grid>

                      {/* Mobile Number */}
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          Mobile Number <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        {/* <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Mobile Number"
                          disabled={!isEditing}
                          error={!!billingerrors.mobile}
                          helperText={billingerrors.mobile?.message}
                          {...Billingregister("mobile", {
                            required: "Mobile number is required",
                            pattern: {
                              value: /^[0-9]+$/,
                              message: "Only numeric values are allowed",
                            },
                            minLength: {
                              value: 10,
                              message: "Mobile number must be at least 10 digits",
                            },
                            maxLength: {
                              value: 12,
                              message: "Mobile number must not exceed 12 digits",
                            },
                          })}
                          inputProps={{
                            maxLength: 12,
                          }}
                          onKeyUp={() => BillingTrigger("mobile")}
                        /> */}
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Mobile Number"
                          disabled={!isEditing}
                          error={!!billingerrors.mobile}
                          helperText={billingerrors.mobile?.message}
                          {...Billingregister("mobile", {
                            required: "Mobile number is required",
                            pattern: {
                              value: /^(?! )[+0-9()\-\s]{8,20}$/, // No space at start; allow +()- and digits
                              message: "Enter a valid number (no space at start, allow +()- and digits)",
                            },
                            minLength: {
                              value: 8,
                              message: "Mobile number must be at least 8 characters",
                            },
                            maxLength: {
                              value: 20,
                              message: "Mobile number must not exceed 20 characters",
                            },
                          })}
                          inputProps={{
                            maxLength: 20,
                            inputMode: "tel",
                          }}
                          onKeyUp={() => BillingTrigger("mobile")}
                        />

                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          Address Line 1 <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Street address, P.O. box"
                          disabled={!isEditing}
                          error={!!billingerrors.addressLine1}
                          helperText={billingerrors.addressLine1?.message}
                          {...Billingregister("addressLine1", {
                            required: "Address Line 1 is required",
                            validate: value =>
                              value.trimStart() === value || "Address Line 1 should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z0-9\s,'-]+$/,
                              message: "Enter a valid address",
                            },
                            maxLength: {
                              value: 50,
                              message: "Address Line 1 cannot exceed 50 characters",  
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("addressLine1"); }}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}> Address Line 2 </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Apartment, suite, unit, etc."
                          disabled={!isEditing}
                          error={!!billingerrors.addressLine2}
                          helperText={billingerrors.addressLine2?.message}
                          {...Billingregister("addressLine2", {
                            validate: (value) =>
                              !value || (typeof value === "string" && value.trimStart() === value) ||
                              "Address Line 2 should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z0-9\s,'-]+$/,
                              message: "Enter a valid address",
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("addressLine2"); }}
                        />
                      </Grid>



                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          State <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="State/Province/Region"
                          disabled={!isEditing}
                          error={!!billingerrors.state}
                          helperText={billingerrors.state?.message}
                          {...Billingregister("state", {
                            required: "State is required",
                            validate: value =>
                              value.trimStart() === value || "State should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z\s]{2,}$/,
                              message: "State should contain only letters",
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("state"); }}

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          City <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="City"
                          disabled={!isEditing}
                          error={!!billingerrors.city}
                          helperText={billingerrors.city?.message}
                          {...Billingregister("city", {
                            required: "City is required",
                            validate: value =>
                              value.trimStart() === value || "City should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z\s]{2,}$/,
                              message: "City should contain only letters",
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("city"); }}

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          Country <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="Country"
                          disabled={!isEditing}
                          error={!!billingerrors.country}
                          helperText={billingerrors.country?.message}
                          {...Billingregister("country", {
                            required: "Country is required",
                            validate: value =>
                              value.trimStart() === value || "Country should not start with a space",
                            pattern: {
                              value: /^[a-zA-Z\s]{2,}$/,
                              message: "Country should contain only letters",
                            },
                          })}
                          onKeyUp={() => { BillingTrigger("country"); }}

                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography variant="body2" fontWeight="500" mb={1}>
                          ZIP <span style={{ color: 'red', fontWeight: 600 }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          variant="outlined"
                          placeholder="ZIP"
                          disabled={!isEditing}
                          error={!!billingerrors.zipCode}
                          helperText={billingerrors.zipCode?.message}
                          {...Billingregister("zipCode", {
                            required: "ZIP Code is required",
                            pattern: {
                              value: /^[0-9]{5,6}$/,
                              message: "ZIP Code must be 5 or 6 digits"
                            }
                          })}
                          onKeyUp={() => { BillingTrigger("zipCode"); }}
                        />
                      </Grid>


                    </Grid>
                    {isEditing ?
                      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 2 }}>
                        <Button variant="outlined" color="primary" onClick={() => { setIsEditing(false); Billingerrors(); getbillingAddress() ;BillingReset();GetData()}} disabled={loader}>
                          Cancel
                        </Button>
                        <Button variant="outlined" color="primary" type="submit" className="button2" disabled={loader}>
                          {loader ? <BeatLoader size={20} color="#fff" /> : <Typography>Submit</Typography>}
                        </Button>
                      </Box> : <Button variant="outlined" sx={{ mt: 2 }} onClick={() => setIsEditing(true)} disabled={isEditing}>Edit</Button>}
                  </form>
                )}
                {tabValue === 3 && (
                  <form onSubmit={handleSubmit1(onPasswordSubmit)} autoComplete="off">
                    <Typography variant="h5" sx={{ fontWeight: 600, textAlign: "center", backgroundColor: "#f5f5f5", padding: "8px", borderRadius: "10px" }}>Change Password</Typography>
                    <Divider sx={{ mt: 1 }} />
                   {setupdata?.is_password_added ? <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>
                        Old Password <span style={{ color: 'red', fontWeight: 800 }}>*</span>
                      </Typography>
                      <TextField
                        sx={{ maxWidth: 500 }}
                        fullWidth
                        variant="outlined"
                        type={showoldPassword ? 'text' : 'password'}
                        {...register1("oldpassword", {
                          required: "Old Password is required",
                          pattern: {
                            value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                            message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter."
                          }
                        })}
                        error={!!errors1?.oldpassword}
                        helperText={errors1?.oldpassword?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleoldPasswordVisibility} edge="end">
                                {showoldPassword ? <IconEye size={22} /> : <IconEyeOff size={22} />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onKeyUp={() => { trigger1("oldpassword"); setError(''); setsuccess('') }}
                      />
                    </FormControl>:""}

                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>
                        New Password <span style={{ color: 'red', fontWeight: 800 }}>*</span>
                      </Typography>
                      <TextField
                        sx={{ maxWidth: 500 }}
                        fullWidth
                        variant="outlined"
                        type={showPassword ? 'text' : 'password'}
                        {...register1("password", {
                          required: "New Password is required",
                          pattern: {
                            value: /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,16}$/,
                            message: "Password must be 8-16 characters, with at least one digit, one lowercase, and one uppercase letter."
                          }
                        })}
                        error={!!errors1?.password}
                        helperText={errors1?.password?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={togglePasswordVisibility} edge="end">
                                {showPassword ? <IconEye size={22} /> : <IconEyeOff size={22} />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onKeyUp={() => { trigger1("password"); setError(''); setsuccess('') }}

                      />
                    </FormControl>

                    <FormControl variant="standard" fullWidth margin="dense">
                      <Typography variant="body2" gutterBottom>
                        Confirm Password <span style={{ color: 'red', fontWeight: 800 }}>*</span>
                      </Typography>
                      <TextField
                        sx={{ maxWidth: 500 }}
                        fullWidth
                        variant="outlined"
                        type={showconfirmPassword ? 'text' : 'password'}
                        {...register1('confirmPassword', {
                          required: "Confirm Password is required",
                          validate: (value) =>
                            value === getValues1("password") || "Passwords do not match"
                        })}
                        error={!!errors1?.confirmPassword}
                        helperText={errors1?.confirmPassword?.message}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleconfirmPasswordVisibility} edge="end">
                                {showconfirmPassword ? <IconEye size={22} /> : <IconEyeOff size={22} />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        onCopy={(e) => e.preventDefault()}
                        onPaste={(e) => e.preventDefault()}
                        onKeyUp={() => { trigger1("confirmPassword"); setError(''); setsuccess('') }}

                      />
                    </FormControl>

                    {Error && (
                      <Box sx={{ mb: 2, textAlign: "center" }}>
                        <Alert severity="error">{Error}</Alert>
                      </Box>
                    )}
                    {/* {success && (
                                    <Box sx={{ mb: 2, textAlign: "center" }}>
                                        <Alert severity="success">{success}</Alert>
                                    </Box>
                                )} */}
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{ mt: 2 }}
                      disabled={loader}
                    >
                      {loader ? <BeatLoader size={20} color="#014670" /> : "Change Password"}
                    </Button>
                  </form>
                )}
              </Grid>
            </Grid>
          </Paper>
        </Box>
        <Dialog
          open={successpopup}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setsuccesspopup(false);
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          sx={{ textAlign: "center" }}
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>

          <Divider />

          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#e6f4ea",
                  padding: 3,
                  "&:hover": { backgroundColor: "#c3e6cb" }
                }}
              >
                <IconCheck color="#28a745" size={50} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Updated Successfully
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { { setsuccesspopup(false) } }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={passwordsuccess}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setpasswordsuccess(false);
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          sx={{ textAlign: "center" }}
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>

          <Divider />

          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#e6f4ea",
                  padding: 3,
                  "&:hover": { backgroundColor: "#c3e6cb" }
                }}
              >
                <IconCheck color="#28a745" size={50} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Your password has been updated successfully.
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { { setpasswordsuccess(false); navigate('/') } }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={Deletepopup}
          onClose={() => setDeletepopup(false)}
          aria-labelledby="confirm-delete-dialog-title"
          aria-describedby="confirm-delete-dialog-description"
          PaperProps={{
            sx: { borderRadius: "16px", padding: "16px" },
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box />
            <IconButton size="small" onClick={() => setDeletepopup(false)}>
              <IconX />
            </IconButton>
          </Box>
          <DialogTitle
            id="confirm-delete-dialog-title"
            align="center"
            sx={{ marginTop: -3 }}
          >
            <Box display="flex" justifyContent="center" alignItems="center">
              <Box
                sx={{
                  width: 60,
                  height: 60,
                  backgroundColor: "#fdecea",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "50%",
                  marginBottom: 2,
                }}
              >
                <IconTrash size={32} color="#e57373" />
              </Box>
            </Box>
            <Typography variant="h6" fontWeight="bold">
              Confirm Delete
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography id="confirm-delete-dialog-description" align="center">
              Are you sure you want to delete your Account ? This action cannot be
              undone.
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              marginBottom: 1,
            }}
          >
            <Button
              variant="outlined"
              color="inherit"
              sx={{
                width: 120,
                borderColor: "#e0e0e0",
              }}
              onClick={() => setDeletepopup(false)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              sx={{ width: 120, backgroundColor: "#c63037", border: "none" }}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={DeleteSuccess}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              setDeleteSuccess(false);
            }
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth="xs"
          sx={{ textAlign: "center" }}
        >
          <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
            Success
          </DialogTitle>

          <Divider />

          <DialogContent>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
              <IconButton
                disableRipple
                sx={{
                  backgroundColor: "#0e860e",
                  padding: 3,
                  "&:hover": { backgroundColor: "#0e860e" }
                }}
              >
                <IconCheck color="#fff" size={30} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              Your Account Deleted Successfully
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { navigate('/') }}
              sx={{
                color: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </PageContainer>
    </>
  );
};

export default MyProfile;
